<template>
  <header class="header">
    <!-- Left: Logo & Restaurant Info -->
    <div class="header-left">
      <img src="/images/MealWaveAsAtext.png" alt="MealWave" class="logo" />
      <div class="divider"></div>
      <div class="restaurant-info">
        <span class="restaurant-name">{{ selectedRestaurantName }}</span>
        <span class="station-badge">{{ selectedStation?.name }}</span>
      </div>
    </div>

    <!-- Right: Status & Actions -->
    <div class="header-right">
      <!-- Connection Status -->
      <div class="status-indicator">
        <span :class="['status-dot', connectionStatus ? 'online' : 'offline']"></span>
        <span class="status-text">{{ connectionStatus ? 'Online' : 'Offline' }}</span>
      </div>

      <!-- Orders Count -->
      <div class="orders-count">
        <span class="count">{{ totalOrdersCount }}</span>
        <span class="label">{{ language === 'ar' ? 'طلبات' : 'Orders' }}</span>
      </div>

      <!-- Settings Button -->
      <button @click="$emit('openSettings')" class="settings-btn" :title="language === 'ar' ? 'الإعدادات' : 'Einstellungen'">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </button>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapState(['selectedRestaurantName', 'selectedStation', 'connectionStatus', 'language']),
    ...mapGetters(['totalOrdersCount'])
  }
};
</script>

<style scoped>
.header { display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; background: var(--ods-surface); border-bottom: 1px solid var(--ods-line); min-height: 56px; }
.header-left { display: flex; align-items: center; gap: 14px; }
.logo { height: 22px; width: auto; display: block; }
html.dark .logo { filter: brightness(1.25); }
.divider { width: 1px; height: 22px; background: var(--ods-line-2); }
.restaurant-info { display: flex; align-items: center; gap: 10px; }
.restaurant-name { font-size: 15px; font-weight: 700; color: var(--ods-ink); line-height: 1; }
.station-badge { font-size: 11px; font-weight: 700; padding: 4px 8px; background: var(--ods-accent-tint); color: var(--ods-accent-ink); border-radius: var(--ods-radius-sm); text-transform: uppercase; letter-spacing: .06em; }
.header-right { display: flex; align-items: center; gap: 16px; }
.status-indicator { display: flex; align-items: center; gap: 8px; }
.status-dot { width: 8px; height: 8px; border-radius: 50%; }
.status-dot.online { background: var(--ods-ok); }
.status-dot.offline { background: var(--ods-danger); }
.status-text { font-size: 13px; color: var(--ods-ink-2); font-weight: 600; }
.orders-count { display: flex; align-items: center; gap: 6px; padding: 6px 10px; background: var(--ods-surface-2); border: 1px solid var(--ods-line); border-radius: var(--ods-radius); }
.orders-count .count { font-size: 16px; font-weight: 800; color: var(--ods-ink); font-variant-numeric: tabular-nums; }
.orders-count .label { font-size: 12px; color: var(--ods-ink-3); font-weight: 600; }
.settings-btn { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: var(--ods-surface-2); border: 1px solid var(--ods-line-2); border-radius: var(--ods-radius); color: var(--ods-ink-2); cursor: pointer; transition: background .15s, color .15s; }
.settings-btn:hover { background: var(--ods-surface-3); color: var(--ods-ink); }
</style>
